module.exports = __webpack_public_path__ + "img/bg.ffbdc463.png";